import './Players.css'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

import { useRemovePlayerMutation } from '../../redux/playersService/playersApiSlice.js'
import { useGetPlayersQuery } from '../../redux/playersService/playersApiSlice.js'
import { findPlayers } from '../../generalExternalFunctions'
import { Header } from '../../components/Header/Header'
import { ReactComponent as MinusDelete } from '../../icon/minus-delete.svg'
import AddButton from '../../components/AddButton/AddButton.js'
import { BottomMenu } from '../../components/BottomMenu/BottomMenu'
import { Input } from '../../components/Input/Input'

import { sortArrayOfObjectsByName } from './externalFunctions'

const Players = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const communityUid = localStorage.getItem('communityUid')
	const { data = [], isLoading } = useGetPlayersQuery({ community_uid: communityUid })
	const [removePlayers] = useRemovePlayerMutation()

	const [players, setPlayers] = useState([])
	const [playerName, setPlayerName] = useState('')

	useEffect(() => {
		if (Object.keys(data).length !== 0) {
			const sortedPlayers = sortArrayOfObjectsByName(data)
			setPlayers(sortedPlayers)
		}
	}, [data])

	const handlePlayer = (item) => {
		sessionStorage.setItem('updatedPlayer', JSON.stringify(item))
		navigate('/account/players/form')
	}

	const searchPlayer = async (value) => {
		setPlayerName(value)

		if (value !== '') {
			const searchedPlayers = findPlayers(value, data)
			setPlayers(searchedPlayers)
		} else {
			setPlayers(data)
		}
	}

	const deletePlayer = async (playerUid) => {
		try {
			const response = await removePlayers({ player_uid: playerUid }).unwrap()

			if (response?.error) {
				return
			}
		} catch (e) {
			console.log('removePlayers catch error', e)
		}
	}

	if (isLoading) return <h1>Loading...</h1>

	return (
		<>
			<Header
				className="header-container"
				backButton={true}
				backButtonPatch={'/account'}
				subtitle={t('Players')}
			/>

			<div className="players__container">
				<div className="players__search">
					<Input
						value={playerName}
						placeholder={t('Search: enter name')}
						onChange={e => searchPlayer(e.target.value)}
					/>
				</div>

				<div className="players__block">
					{
						players.length < 1 &&
						<div className="noplayers-container">
							<p className="noplayers-text">
								{t('There are no players. Add a player using the button')} (+)
							</p>
						</div>
					}

					{
						players.map((item, index) => (
							<div className="players__wrapper" key={index}>
								<div onClick={() => handlePlayer(item)} className="players__name-container">
									<div className="players__number-container">
										<p className="players__number">
											{index + 1}
										</p>
									</div>

									<p className="players__name">
										{item?.last_name} {item?.first_name}
									</p>
								</div>

								<MinusDelete
									className="players__delete-button"
									onClick={() => deletePlayer(item?.uid)}
								/>
							</div>
						))
					}

					{
						players?.length < 33 &&
						<AddButton
							onClick={() => sessionStorage.removeItem('updatedPlayer')}
							to={'/account/players/form'}
						/>
					}
				</div>
			</div>

			<BottomMenu />
		</>
	)
}

export default Players
